Prelogin = (function (prelogin) {
    prelogin.Features = {};
    const me = prelogin.Features;

    let featureSlideshowHeight = $('#slideshow').outerHeight();
    const featureSlideshowOptions = {
        cellAlign: 'left',
        contain: true,
        cellSelector: 'img',
        prevNextButtons: false,
        autoPlay: 4000,
        resize: true,
        lazyLoad: 2,
        pageDots: false,
    };

    me.init = function () {
        // initialize slideshow within laptop screen
        $('#slideshow').flickity(featureSlideshowOptions);

        // when hovering on list item, update slideshow
        $('#slideshow-nav').on('mouseenter ', 'li', function () {
            const index = $(this).attr('data-slide');
            $('#slideshow').flickity('pausePlayer');
            $('#slideshow').flickity('select', index);
        });

        // when done hovering, resume autoplay of slideshow...
        $('#slideshow-nav').on('mouseleave ', 'li', () => {
            $('#slideshow').flickity('unpausePlayer');
        });

        // calibrate slideshow if browser resizes...
        $(window).on(
            'resize',
            _.debounce(() => {
                if ($('#slideshow').outerHeight() !== featureSlideshowHeight) {
                    $('#slideshow').flickity('destroy');
                    $('#slideshow').flickity(featureSlideshowOptions);
                    featureSlideshowHeight = $('#slideshow').outerHeight();
                }
            }, 250),
        );

        setupAnimations();
    };

    const setupAnimations = () => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.utils.toArray('#slideshow-nav li').forEach((box) => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: box,
                    toggleActions: 'restart none none none',
                    start: 'top 95%',
                },
            });

            tl.from(box, {
                x: '-700px',
                duration: 0.75,
                opacity: 0,
            });
        });

        const laptop = $('#laptop-container');
        gsap.from(laptop, {
            x: '+=50px',
            duration: 1,
            opacity: '0.8',
            scrollTrigger: {
                trigger: '#laptop-container',
                toggleActions: 'restart none none none',
                start: 'top 50%',
            },
        });

        gsap.utils.toArray('#travel-guides .character, .values-list li').forEach((box) => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: box,
                    toggleActions: 'restart none none none',
                    start: 'top 95%',
                },
            });

            tl.from(box, {
                scale: '0.7',
                duration: 0.75,
                opacity: 0,
            });
        });
    };

    return prelogin;
}(Prelogin || {}));
